// tslint:disable
import React, { useState, useEffect, useContext } from 'react';
import { IRootState } from 'src/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { useFetch } from 'use-http';
import _ from 'lodash';
import { Url } from 'src/api';
import TownshipCard from './TownshipCard';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import { push } from 'connected-react-router';
import { LandSystem } from 'src/models/LandSystem';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import SearchListData from 'src/models/SearchListData';

interface ITownshipListProps {
    setTractListId: (tractListId: number) => void;
    landSystem: LandSystem;
    searchFilterData?: SearchListData[];
    filterTownships?: boolean;
    refreshTags?: () => void;
}

const TownshipList: React.FC<ITownshipListProps> = (props) => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { get, response } = useFetch();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [sectionSearchTerm, setSectionSearchTerm] = useState('');
    const [filterTownships, setFilterTownships] = useState(false);
    const [townshipIds, setTownshipIds] = useState<number[]>([]);
    const [selectedTownship, setSelectedTownship] = useState(undefined);
    const [selectedSection, setSelectedSection] = useState(undefined);
    const dialogContext = useContext<dialogCreators>(DialogContext);
    const [filterDataOptions, setFilterDataOptions] = useState<ODataOptions>(new ODataOptions);
    const [searchFilterData, setSearchFilterData] = useState<Array<SearchListData>>([]);
    const dispatch = useDispatch();

    const getFilteredTownshipIds = async () => {
        const filteredTownshipIds = await get(`${Url.project.getTownships(appContext)}/tags/${filterDataOptions.toString()}`);

        if (response.ok) {
            setTownshipIds(filteredTownshipIds);
        }
    }

    useEffect(() => {
        let newDataOptions = _.cloneDeep(filterDataOptions);
        let hadFilters = newDataOptions.hasFilters();
        newDataOptions?.clearFilters('KUDUTags');
        if (filterTownships === true) {
            for ( let tagListIndex = 0; tagListIndex < searchFilterData?.length; tagListIndex++) {
                if (searchFilterData[tagListIndex].state === true) {
                    newDataOptions?.addFilter(new ODataFilter('KUDUTags', ODataFilterOperators.Equals, searchFilterData[tagListIndex].tag.name));
                }
            }
            if (newDataOptions.hasFilters() || hadFilters) {
                setFilterDataOptions(newDataOptions);
            }
        }
    }, [searchFilterData]);

    const loadInitialData = async () => {
        const data = await get(`${Url.project.getAreas(appContext)}?select=id`);
        let townshipIdForSection: number = undefined;

        const tableConfig: ITableConfig = {
            rowCount: 20,
            idField: 'id',
            pageNumber: 1,
            columns: []
        };
        let dataOptions = ODataOptions.from(tableConfig);
        dataOptions.addOrderBy('TownshipNumber', ODataOrderByDirection.Ascending);
        setFilterDataOptions(dataOptions);

        if (appContext.sectionNumber) {
            const township = await get(`${Url.project.getSection(appContext, appContext.sectionNumber)}/township`);
            townshipIdForSection = township;
        }

        if (response.ok) {
            setTownshipIds(data);
            if (townshipIdForSection) {
                setSelectedTownship(data[(data as number[]).indexOf(townshipIdForSection)]);
            } else {
                setSelectedTownship(undefined);
            }
            setDataLoaded(true);
        }
    };

    const findSections_Tracts = () => {
        let section = '';
        let tract = '';
        if (sectionSearchTerm.search('.') > -1) {
            const searchTokens = sectionSearchTerm.split('.');
            section = searchTokens?.length > 0 ? searchTokens[0] : '0';
            tract = searchTokens?.length > 1 ? searchTokens[1] : '0';
            if (searchTokens?.length > 0) {
                findSection();
            }
        }
        
        let urlSuffix = '';
        if (tract !== '0') {
            urlSuffix = `/tracts/${tract}/horizons/1`;
            dispatch(push(`/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/sections/${section}` + urlSuffix));
        }
    }

    const onTownshipSelected = (townshipId: number) => {
        dispatch(push(`/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/tracts`));
        setSelectedTownship(townshipId);
    };

    const reloadTownships = async (townshipId: number) => {
        setDataLoaded(false);
        setTownshipIds([]);
        await loadInitialData();
        setSelectedTownship(townshipId);
        props.refreshTags();
    };

    const findSection = async () => {
        let sectionNumber: number | string = 0;
        if (!isNaN(Number(sectionSearchTerm))) {
            sectionNumber = Number(sectionSearchTerm);
        }
        const townshipNumber = await get(`${Url.project.getSection(appContext, sectionNumber)}/township`);
        if (response.ok) {            
            setSelectedSection(sectionNumber);
            setSelectedTownship(townshipNumber);
        }
    };

    useEffect(() => {
        loadInitialData();
    }, []);

    useEffect(() => {
        if (filterDataOptions?.hasFilters()) {
            getFilteredTownshipIds();
        } else if (filterDataOptions.getOrderByProperty() === "TownshipNumber") {
            getFilteredTownshipIds();
        }
    }, [filterDataOptions]);

    useEffect(() => {
        if (props?.searchFilterData?.length > 0) {
            setSearchFilterData(props.searchFilterData);
            console.log(searchFilterData);
        }
    }, [props.searchFilterData]);

    useEffect(() => {
        setFilterTownships(props.filterTownships);
        if (props.filterTownships !== undefined) {
            let newDataOptions = _.cloneDeep(filterDataOptions);
            newDataOptions?.clearFilters('KUDUTags');
            if (props.filterTownships === true) {
                for ( let tagListIndex = 0; tagListIndex < searchFilterData?.length; tagListIndex++) {
                    if (searchFilterData[tagListIndex].state === true) {
                        newDataOptions?.addFilter(new ODataFilter('KUDUTags', ODataFilterOperators.Equals, searchFilterData[tagListIndex].tag.name));
                    }
                }
            }
            setFilterDataOptions(newDataOptions);
        }
    }, [props.filterTownships]);

    if (!dataLoaded) {
        return <div>Loading...</div>;
    } else if (townshipIds.length === 0) {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1rem', background: '#ddd', padding: '.8rem' }}>
                    <div style={{ height: '100%', verticalAlign: 'center', fontWeight: 'bold', fontSize: '1.3em' }}>Townships</div>
                    <div>
                        <Button
                            size="small"
                            intent="primary"
                            text="Create Township"
                            onClick={() => dialogContext.project.addUpdateDeleteTownship(0, 'create', props.landSystem, reloadTownships)}
                        />
                    </div>
                </div>
                <div style={{ padding: '2rem', border: '2px red solid', margin: '1rem', textAlign: 'center', fontWeight: 'bold', fontSize: '1.1em' }}>
                    No Townships Found.
                </div>
            </>
        );
    } else {
        return (
            <>
                {/* <Filter items={[]} /> */}
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1rem', background: '#ddd', padding: '.8rem' }}>
                    <div style={{ height: '100%', verticalAlign: 'center', fontWeight: 'bold', fontSize: '1.3em' }}>Townships</div>
                    <div>
                        <input
                            size={16}
                            type="text"
                            name={`sectionSearch`}
                            id={`section-tract-search`}
                            hidden={false}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setSectionSearchTerm(e.target.value)
                            }
                            onClick={() => (document.getElementById('section-tract-search') as HTMLInputElement).value === `[Section/Map #].[Tract #]` ?
                            (document.getElementById('section-tract-search') as HTMLInputElement).value = '' : false}
                            maxLength={15}
                            defaultValue={`[Section/Map #].[Tract #]`}
                        />
                        <Button
                            size="small"
                            intent="primary"
                            text="Find Tracts"
                            onClick={() =>
                                findSections_Tracts()
                            }
                        />
                    </div>
                    <div>
                        <Button
                            size="small"
                            intent="primary"
                            text="Create Township"
                            onClick={() =>
                                dialogContext.project.addUpdateDeleteTownship(0, 'create', props.landSystem, async (townshipId: number) => {
                                    props.setTractListId(undefined);
                                    await reloadTownships(townshipId);
                                    setSelectedTownship(townshipId);
                                })
                            }
                        />
                    </div>
                </div>
                <CardContainer>
                    {townshipIds.map((id) => (
                        <TownshipCard
                            key={id}
                            townshipId={id}
                            isActive={selectedTownship === id}
                            onTownshipSelected={onTownshipSelected}
                            onSectionSelected={props.setTractListId}
                            parentSelectedSection={selectedSection}
                            reloadTownships={reloadTownships}
                            landSystem={props.landSystem}
                        />
                    ))}
                </CardContainer>
            </>
        );
    }
};

export default TownshipList;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/components/TownshipList.tsx